import api from '@/api'

export default {
  all: (filter) => api('get', '/type', filter),
  create: (data) => api('post', '/type', data),
  show: (id) => api('get', `/type/${id}`),
  delete: (id) => api('delete', `/type/${id}`),
  update: (data) => api('put', `/type/${data.id}`, data)
}
